import Isotope from 'isotope-layout';

class NineflowIsotope {
	constructor(config) {
		this.config = Object.assign({
			scope: '.isotope',
			itemSelector: '.isotope-item'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((index, element) => {
			let $scope = $(element);
			let settings = this.#getSettings($scope);
			let iso = new Isotope(element, settings);

			$scope.find('img').each((imageIndex, image) => {
				image.addEventListener('load', () => {
					iso.layout();
				})
			});

			// iso.layout();
		});
	}

	#getSettings($scope) {
		let settings = this.#getDefaultSettings();
		if ($scope.data('layoutMode') == 'masonry' || !$scope.data('layoutMode')) {
			settings.masonry = {
				horizontalOrder: true
			}
		}
		return Object.assign(settings, $scope.data());
	}

	#getDefaultSettings() {
		return {
			itemSelector: this.config.itemSelector,
			percentPosition: false
		}
	}
}

export default NineflowIsotope;
